import React, { useLayoutEffect, useRef, useState } from 'react';
import ImageCaption from './ImageCaption';
import type { CarouselItem } from './types';
import Slot from '../../components/Slot';

interface CarouselCaptionProps {
  image: CarouselItem;
  onCaptionChange: (image: CarouselItem, caption: string) => void;
  active: boolean;
}

const CarouselCaption = React.forwardRef<HTMLDivElement, CarouselCaptionProps>(
  ({ image, onCaptionChange, active }, ref) => {
    const captionRef = useRef<HTMLDivElement>(null);

    const [minHeight, setMinHeight] = useState<number | undefined>(undefined);

    useLayoutEffect(() => {
      const captionEl = captionRef.current;
      if (!captionEl) return;

      setMinHeight((current) =>
        active ? Math.max(current ?? 0, captionEl.offsetHeight) : undefined,
      );
    }, [image, active]);

    return (
      <Slot ref={ref}>
        <ImageCaption
          ref={captionRef}
          minHeight={minHeight}
          caption={image.caption ?? ''}
          onCaptionChange={(caption) => onCaptionChange(image, caption)}
        />
      </Slot>
    );
  },
);

export default CarouselCaption;
